<!--
 * @Author: Merlin
 * @Date: 2024-08-23 18:03:32
 * @LastEditors: Merlin
 * @LastEditTime: 2024-10-11 10:37:33
 * @Description:  
-->
<template>
    <div>
        <q-menu 
            v-model="isShowSelf" 
            :offset="offset" 
            :style="{ background: 'transparent' }"
            aaamax-width="280px"
        >
            <ul class="dropdown-menu" > 
                <li
                    v-for="(oCoin, idx) of aCoinArr"
                    :key="idx"
                    class="menu-item"
                    :class="{
                        'active-coin': oCoin.pairName === sActiveCoin,
                    }"
                    @click="choseCoin(oCoin)" 
                >
                    <em class="left">
                        <img class="icon" :src="oCoin.icon" /> 
                        {{oCoin.name}}
                    </em>
                    <!-- 
                        ↑ 左侧币种图标
                        ↓ 右侧涨跌标记 
                    -->
                    <span class="right">
                        {{
                            number2LocaleString(oCoin.value, oCoin.precision)
                        }}
                        <IconSvgUse
                            class="svg" 
                            size="18px" 
                            :use="oCoin.iconName" 
                            :style="{color: oCoin.color}" 
                        />
                    </span>
                </li>
            </ul>
        </q-menu>
    </div> 
</template>

<script lang="ts" setup>
import { 
    aCoinList,
    oColorInfo,
} from '../ts/wavesData'; 
// import { aa, } from '../ts/wavesFn'; 
import { cryptoIcons } from '@/utils/cryptos'

import {
    chartState_r,
    settingsState_f,
    fnGetChartStateToolbox_oi,
    oWavesBetForm_a, 
    fnGameForm_Ot,
    fnSettingCenter_Ft, 
} from '../ts/wavesControlCenter'; 

const { setCoin } = useFuturesStore()
const props = defineProps({ 
    modelValue: { // 控制可见性 
        type: Boolean, 
    },
    calculatorPair: {
        type: String, // 计算器窗口的币种，收到值，表示在计算器窗口 
    },
    offset: {
        type: Array,
        default: () => [0, 0],
    },
});

const emit = defineEmits([
    'update:modelValue',
    'update:calculatorPair',
]); 

const oChartState = fnGetChartStateToolbox_oi();
const oSettingCenter = fnSettingCenter_Ft(); 
const isShowSelf = computed({ 
    get(){
        return props.modelValue; 
    },
    set(newVal){
        emit('update:modelValue', !!newVal); 
    },
});

// ↓ 关键 🔶 列表 
const aCoinArr = computed(()=>{
    const oAllPair = chartState_r.currentPairsPrices || {};
    const oSetting = settingsState_f.pairsSettings || {};
    const keys = Object.keys(oSetting);
    const aResult = keys.map(pairName => {
        const oOnePair = oAllPair[pairName] || {};
        const status = oOnePair.status || 0;
        const oTarget = oColorInfo[status];
        const oPairSetting = oSetting[pairName] || {};
        const name = pairName.split('_')[0];
        const oCoin = {
            pairName,
            name,
            icon: cryptoIcons[name],
            status,
            value: oOnePair.value || 0,
            color: oTarget.color,
            iconName: oTarget.icon02,
            precision: oPairSetting.precision || 2,
            weight: oPairSetting.weight || 1,
        };
        return oCoin;
    })
    aResult.sort((aa, bb)=>{
        return aa.weight - bb.weight; 
    });
    return aResult;
});


const sActiveCoin = computed({
    get(){
        // ↓ 在计算器窗口使用 
        if (props.calculatorPair) {
            return props.calculatorPair;
        }
        // ↓ 在游戏界面使用 
        const route = useRoute(); 
        const sCoinOfRoute = route.params.id; 
        return `${sCoinOfRoute}_USDT`;
    },
    set(sNewValue){
        emit('update:calculatorPair', sNewValue); // 上报 
    },
}); 


// ↓ 切换当前币种 
const choseCoin = async (oCoin) => { 
    // ↓ 先关闭菜单 
    emit('update:modelValue', false);
    await nextTick(); 
    // console.log('oCoin', deepCopy(oCoin)); 
    if (props.calculatorPair){
        sActiveCoin.value = oCoin.pairName; // 赋值 
        return;
    } 
    // ↑ 在计算器窗口使用，
    // ↓ 在游戏界面使用 
    await Sleep(100);
    // ↓ 跳到新地址 
    const sPath = `/casino/futuresGame/${oCoin.name}`;
    useNavigator(sPath);
};

watch(() => settingsState_f.pairsSettings, (val) => {
    const keys = Object.keys(val).sort(
        (a, b) => val[a].weight - val[b].weight
    )
    setCoin(keys.map(name => name.split('_')[0]))
})
</script>

<style scoped lang="scss">
.dropdown-menu{
    background-color: var(--Background-Senary);
    border-color: var(--Background-Senary);
    border-style: solid;
    box-shadow: 2px 2px 20px #0000004d;
    border-radius: 10px;
    border-width: 2px;
    font-size: 14px;
    padding: 2px;
    z-index: 1;
    padding: 12px;
}

.menu-item{
    display: flex;
    width: 280px;
    padding: 8px 10px;
    justify-content: space-between;
    font-size: 16px;
    color: white;
    font-weight: 600;
    border-radius: 6px;
    cursor: pointer;
    margin: 0 0 1px; 
    &:hover,
    &.active-coin{
        background: var(--Background-Quaternary);
    }
}

.menu-item .left{
    display: flex;
    align-items: center;
    .icon{
        width: 24px;
        display: inline-block;
        margin: 0 6px 0 0;
    }
}

.menu-item .right{
    opacity: 1; 
    font-size: 14px;
    display: flex;
    align-items: center; 
    font-feature-settings: "tnum" on, "lnum" on; 
    .svg{
        display: inline-block;
        margin: 0 0 0 3px; 
    }
}


</style>

